import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class ProductApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/product' + path, queryMap);
  }

  findPlatformCategories() {
    const url = this.buildurl('/platform/categories');
    // const url = this.buildurl('/prent/class/platform/categories');
    return this.http.fget(url);
  }

  findPlatformsByCategory(id: number) {
    const url = this.buildurl('/platforms', { category_id: id });
    return this.http.fget(url);
  }

  findBusTypesByPlatform(id: number) {
    const url = this.buildurl(`/platform/${id}/bus/types`);
    return this.http.fget(url);
  }

  getBusType(id: number) {
    const url = this.buildurl(`/bus/type/${id}`);
    return this.http.fget(url);
  }

  getBusAccountInvitationLink(id: number) {
    const url = this.buildurl(`/bus/account/invitation/link/${id}`);
    return this.http.fget(url);
  }

  getPlatform(id: number) {
    const url = this.buildurl(`/platform/${id}`);
    return this.http.fget(url);
  }

  getPopcornBusType(id: number) {
    const url = this.buildurl(`/platform/${id}/popcorn/types`);
    return this.http.fget(url);
  }

  findBusTypesByPlatformNew(platform_id: number) {
    const url = this.buildurl('/platform/new/bus/types', { platform_id });
    return this.http.fget(url);
  }

  findSelected() {
    const url = this.buildurl('/platforms/card');
    return this.http.fget(url);
  }

  findSeller() {
    const url = this.buildurl('/platforms/best/seller');
    return this.http.fget(url);
  }
}
